import { supabase, testDirectConnection } from '../config/supabaseClient'
import { Rant } from '../types'

export const saveRantToDatabase = async (
  rant: Omit<Rant, 'hasVoted'>,
): Promise<void> => {
  // Check if user is logged in
  const {
    data: { user },
  } = await supabase.auth.getUser()

  const { error } = await supabase.from('rants').insert({
    text: rant.text,
    category: rant.category,
    votes: rant.votes,
    timestamp: new Date(rant.timestamp).toISOString(),
    user_id: user?.id || null,
  })

  if (error) {
    console.error('Error saving rant:', error)
    throw error
  }
}

export const getRantsFromDatabase = async (): Promise<Rant[]> => {
  console.log('📥 Starting rant fetch...')
  try {
    // Use raw fetch since it's working reliably
    console.log('🔍 Fetching rants with raw fetch...')
    const response = await fetch(
      'https://usvaxxafjnoqvwmxkygq.supabase.co/rest/v1/rants?select=*&order=timestamp.desc',
      {
        headers: {
          apikey:
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVzdmF4eGFmam5vcXZ3bXhreWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2NTk0MzIsImV4cCI6MjA3OTIzNTQzMn0._ghSkUXA34sFTW0bBS6wVgcL-TTweUvNDUrr0hP_Eew',
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVzdmF4eGFmam5vcXZ3bXhreWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2NTk0MzIsImV4cCI6MjA3OTIzNTQzMn0._ghSkUXA34sFTW0bBS6wVgcL-TTweUvNDUrr0hP_Eew',
          'Content-Type': 'application/json',
        },
      },
    )
    if (!response.ok) {
      console.error('❌ Fetch failed:', response.status, response.statusText)
      return []
    }
    const data = await response.json()
    console.log('✅ Successfully fetched', data.length, 'rants')
    if (!data || data.length === 0) {
      console.log('⚠️ No rants found')
      return []
    }
    const votedRants = getVotedRantsFromLocalStorage()
    return data.map((row: any) => ({
      id: row.id,
      text: row.text,
      category: row.category,
      votes: row.votes,
      timestamp: new Date(row.timestamp).getTime(),
      hasVoted: votedRants.includes(row.id),
      replyCount: 0,
    }))
  } catch (error) {
    console.error('❌ Exception:', error)
    return []
  }
}

export const updateRantVote = async (rantId: string): Promise<void> => {
  // First, get current votes
  const { data, error: fetchError } = await supabase
    .from('rants')
    .select('votes')
    .eq('id', rantId)
    .single()

  if (fetchError) {
    console.error('Error fetching rant:', fetchError)
    throw fetchError
  }

  // Increment votes
  const { error: updateError } = await supabase
    .from('rants')
    .update({ votes: data.votes + 1 })
    .eq('id', rantId)

  if (updateError) {
    console.error('Error updating votes:', updateError)
    throw updateError
  }

  // Save to localStorage that user voted
  saveVotedRantToLocalStorage(rantId)
}

// Helper functions for tracking votes locally
const getVotedRantsFromLocalStorage = (): string[] => {
  const voted = localStorage.getItem('votedRants')
  return voted ? JSON.parse(voted) : []
}

const saveVotedRantToLocalStorage = (rantId: string): void => {
  const voted = getVotedRantsFromLocalStorage()
  if (!voted.includes(rantId)) {
    voted.push(rantId)
    localStorage.setItem('votedRants', JSON.stringify(voted))
  }
}
